const permissions = {
  /* Document Library Permissions */
  viewDocumentsLibrary: 'view_documents_library',
  createPmcDirectories: 'create_pmc_directories',
  createBuildingDirectories: 'create_building_directories',
  updatePmcDirectories: 'update_pmc_directories',
  updateBuildingDirectories: 'update_building_directories',
  updateDirectoryRoles: 'update_directory_roles',
  createPmcDocuments: 'create_pmc_documents',
  createBuildingDocuments: 'create_building_documents',
  deletePmcDirectories: 'delete_pmc_directories',
  deleteBuildingDirectories: 'delete_building_directories',
  deletePmcDocuments: 'delete_pmc_documents',
  deleteBuildingDocuments: 'delete_building_documents',
  sendDocumentAsMessage: 'send_document_as_message',
  updateOwnPmcDirectories: 'update_own_pmc_directories',
  updateOwnBuildingDirectories: 'update_own_building_directories',
  deleteOwnBuildingDirectories: 'delete_own_building_directories',
  deleteOwnPmcDirectories: 'delete_own_pmc_directories',
  deleteOwnBuildingDocuments: 'delete_own_building_documents',
  deleteOwnPmcDocuments: 'delete_own_pmc_documents',
  /* Access Permissions */
  accessAdmin: 'access_admin',
  /* Messages Permissions */
  send_message_to_group: 'send_message_to_group',
  /* Community Permissions */
  create_community_post: 'create_community_post',
  update_community_post: 'update_community_post',
  delete_community_post: 'delete_community_post',
  view_community_posts: 'view_community_posts',
  add_community_post_comment: 'add_community_post_comment',
  opt_in_community: 'opt_in_community',
  opt_out_community: 'opt_out_community',
  approve_community_post: 'approve_community_post',
  // Staff Log Permissions
  create_staff_log_post: 'create_staff_log_post',
  create_staff_log_comment: 'create_staff_log_comment',
  delete_staff_log_entry: 'delete_staff_log_entry',
  // Service requests permissions
  update_service_request_priority: 'update_service_request_priority',
  view_service_request_priority: 'view_service_request_priority',
  approve_amenity_reservation: 'approve_amenity_reservation',
  edit_social_event: 'edit_social_event',
  // Home feed, building guide and your wellbeing Permissions
  add_building_content_card: 'add_building_content_card',
  update_building_content_card: 'update_building_content_card',
  delete_building_content_card: 'delete_building_content_card',
};

export default permissions;
